const urlBaseResources = process.env.REACT_APP_RESOURCES_BASE_URL;
const urlBaseResourcesMobile = process.env.REACT_APP_RESOURCES_MOBILE_BASE_URL;
const urlBasePayment = process.env.REACT_APP_PAYMENT_API_BASE_URL;
const urlBucketResources = process.env.REACT_APP_RESOURCES_BUCKET;

export const URL_RESOURCES = {
  logos: `${urlBaseResources}/img/logos/`,
  flags: `${urlBaseResourcesMobile}/img/flags/`,
  channels: `${urlBaseResourcesMobile}/img/channels/`,
  currrencies: `${urlBaseResourcesMobile}/img/currrencies/`,
  paymentMethods: `${urlBaseResourcesMobile}/img/payment_methods/`,
  refunds: `${urlBaseResourcesMobile}/img/refund_methods/`,
  banks: `${urlBaseResourcesMobile}/img/banks/`,
  merchants: `${urlBaseResourcesMobile}/img/merchants/`,
  resellers: `${urlBaseResources}/img/resellers/`,
  globals: `${urlBucketResources}/img/globals/`,
};

export const IMG_RESOURCES = {
  success: `${urlBucketResources}/img/globals/success.png`,
};

const END_POINTS = {
  initOneTouch: '/v1/onetouch/:token', // GET MAPI
  init: '/v1/appinit',
  getCountryByIp: '/v1/country/iso',
  getCountries: '/v1/countries',
  getCountryConfig: '/v1/countries/config',

  //IDENTITY
  updateJumioState: '/v1/users/updateStatus',
  updateIdentityValidationState: '/v1/kyc_document/updateKycStatus',
  getIdentityValidationUrl: '/v1/kyc_document/init',
  postIdentityValidationUrl: '/v1/kyc/init',
  checkIdentityStatus: '/v1/users/profile', //GET
  submitOnFidoEvent: 'v1/kyc_document/kycEvent',

  //USER
  loginSignup: '/v2/auth/code',
  faceLoginSignup: '/v4/auth/signIn',
  logout: '/v1/auth/revoke',
  codeValidate: '/v2/auth/code/validate',
  resendCode: '/v2/auth/code',
  resendEmail: 'v1/users/resendEmail',
  userProfile: '/v1/users/profile',
  userDetails: '/v2/users/me',
  userRefresh: '/v2/users/me', //'/v2/auth/refresh'
  channels: '/v2/auth/channel/:country',
  getCookiesAuth: 'v3/auth',

  //DEPOSIT
  depositLanding: '/v1/merchant/deposit/landing', //post mapi
  getMerchantDepositDetail: '/v1/merchant/public/deposit/:token', //get mapi
  getGatewayDepositDetail: '/v3/merchant/deposit/:token',
  getGatewayDirectDeposit: '/v3/merchant/public/payment/create?deposit_external_id=:token',
  getDepositDetail: '/v2/merchant/deposit/:token', //get mapi
  getPaymentMethods: '/v3/paymentMethods', //get mapi
  getAnonymousPaymentMethods: '/v3/paymentMethods/anonymous', //get mapi
  getPaymentStatus: '/v1/wallet/purchase/:purchaseId', //get mapi
  getDepositStatus: '/v1/merchant/public/deposit/:token/status', //get mapi

  walletDeposit: '/v1/merchant/deposit', //post mapi
  deposit: '/v2/users/purchase', //post mapi
  defaultPM: 'v1/users/settings/paymentMethods/default', //post mapi
  pushNotification: `/v1/merchant/deposit/notify/confirm`, // post mapi

  //VOUCHERS
  manualDeposit: '/v1/merchant/public/deposit/voucher', //post mapi
  manualDepositViaMapi: '/v1/merchant/deposit/voucher', //post mapi
  getCardsList: '/v1/voucher/user', //get mapi
  getCardsInfo: '/v2/cards', //get mapi
  // GET /v1/merchant/deposit/card/authorization

  //PROMO CODE
  submitPromoCode: '/v1/merchant/deposit/promoCode/associate',

  //PREVIEW
  getPreviewAuth: '/v1/purchases/preview/authorization', //post
  getPreviewSummary: '/v1/purchases/preview/summary', //post
  getAnonymousPreviewSummary: '/v1/purchases/preview/summary/anonymous?country=:country',

  //CREDIT CARDS
  getCreditCards: 'v1/payment-elements', //get mapi,
  createCreditCard: 'v1/purchases/payment-elements', //post mapi

  //CASHOUT
  getCashoutInfo: 'v1/merchant/public/cashout/:token', //get mapi
  getBeneficiaries: '/v1/withdrawal/beneficiaries', // get mapi
  getMethodConfig: '/v1/withdrawal/methods/:code', // get mapi

  cashout: '/v1/merchant/cashout', // post mapi
  validateWithWallet: '/v1/merchant/cashout/withdrawal/validate', //post mapi

  //CASHOUT WITHDRAW V2
  withdrawalPreviewSummary: '/v2/withdrawals/preview/summary', //post mapi
  withdrawalPreviewAuthorization: '/v2/withdrawals/preview/authorization', //post mapi
  createWithdrawal: '/v2/merchant/cashout/withdrawal/intention', //post mapi

  getWalletTransfer: '/v1/wallet/transfer/pending/:token',
  pLDetailsPublic: '/v2/pl/link/:pLExternalId', //post mapi
  pLDetails: '/v3/pl/link/:pLExternalId/buyer', //post mapi
  pLWallet: 'v1/pl/pay', //post mapi
  pLInvoce: '/v2/pl/invoice/:referenceId', //post mapi
  pLGetPaymentStatus: '/v1/wallet/paymentLink/purchase/:purchaseId', //get mapi

  notifyWrongNumber: '/v1/wallet/transfer/cancel/:token',

  //PAYMENT
  pay: `${urlBasePayment}/v1/payin/:paymentExternalId`, //get payment-api

  //MICROMERCHANTS
  createMicroMerchant: '/v1/platform/onboarding/complete',
  publicOnboardingStatus: 'v1/platform/public/onboarding/proxy/:onboardingExternalId',
  onboardingStatus: 'v1/platform/onboarding/:onboardingExternalId',

  //SIGNIN
  openIdStatus: '/v3/users/openid/status?clientId=:id',
  openIdConsent: '/v3/users/openid/consent', //POST
  openIdIssueToken: '/v3/users/openid/issueSignInToken', //POST
};

export const SingularBaseLink = 'https://astropay.sng.link/A2h2a/2rdc';

export default END_POINTS;
